<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <v-card>
      <v-card-title class="display-3">
        Warme Getränke
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
        ><template v-slot:item.getraenk="{ item }">
          <b>{{ item.getraenk }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Warmegetraenke',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/cappucino.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        { text: 'Getränke', value: 'getraenk' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          getraenk: 'Großer Kaffee',
          preis: '4,70 €',
        },
        {
          getraenk: 'Kleiner Kaffee',
          preis: '3,40 €',
        },
        {
          getraenk: 'Melange (G)',
          preis: '4,20 €',
        },
        {
          getraenk: 'Cappuccino (G)',
          preis: '4,70 €',
        },
        {
          getraenk: 'Schwarzer Tee',
          preis: '4,00 €',
        },
        {
          getraenk: 'Früchte Tee',
          preis: '4,00 €',
        },
        {
          getraenk: 'Jasmin Tee',
          preis: '4,00 €',
        },
        {
          getraenk: 'Grüner Tee',
          preis: '4,00 €',
        },
        {
          getraenk: 'Reis Tee',
          preis: '4,20 €',
        },
        {
          getraenk: 'Ingwer Tee',
          preis: '5,20 €',
        },
        {
          getraenk: 'Kamillen Tee',
          preis: '4,00 €',
        },
        {
          getraenk: 'Pfefferminz Tee',
          preis: '4,00 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
